//import "react-image-crop/dist/ReactCrop.css";
import { useState } from "react";
import { Route, Routes, Navigate } from 'react-router-dom';

import Spinner from './components/Spinner';
import { useAuthContext } from './hooks/useAuthContext';
import { useQuery } from '@apollo/client';
import { IS_AUTHENTICATED } from './queries/isAuthenticatedQuery';
import { useLogout } from './hooks/useLogout';

import Sidebar from './components/Sidebar';
import RightPanel from './components/RightPanel';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Post from './pages/Post';
import NotFound from './pages/NotFound';
import Notifications from './pages/Notifications/Notifications';
import SavedPosts from './pages/SavedPosts';
import img from './assets/purble.jpg';
import { PostsContextProvider } from "./context/PostsContext";

function App() {
  const { authUser, isLoading } = useAuthContext()
  const { logout } = useLogout()
  const [loadingImage, setLoadingImage] = useState(true)

  useQuery(IS_AUTHENTICATED, {
    onCompleted: ({ isAuthenticated }) => {
      if (!isAuthenticated) {
        logout()
      }
    }
  })

  if (isLoading) return <Spinner marginSize='100px' />

  return (
    <>
      {authUser ?
        <div className="row">
          <PostsContextProvider>
            <div className="col-2 col-md-3 col-xl-2 bg-dark z-1">
              <Sidebar />
            </div>
            <div className="col-10 col-xs-9 col-md-7 col-xl-8 py-3">
              <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/users/:id' element={<Profile />} />
                <Route path='/users/:id/notifications' element={<Notifications />} />
                <Route path='/users/:id/savedPosts' element={<SavedPosts />} />
                <Route path='/posts/:id' element={<Post />} />
                <Route path='*' element={<NotFound />} />
                <Route path='/signup' element={<Navigate to='/' />} />
                <Route path='/login' element={<Navigate to='/' />} />
              </Routes>
            </div>
            <div className='col-2 my-4 z-1 d-none d-md-inline'>
              <RightPanel />
            </div>
          </PostsContextProvider>
        </div>
        : <div className="row">
          <div className="col-xl-6">
            {loadingImage && <div className='vh-100'>
              <Spinner marginSize='300px' />
            </div>}
            <img
              src={img}
              className="d-none"
              onLoad={() => setLoadingImage(false)}
              onError={() => setLoadingImage(false)}
            />
            {!loadingImage && <img
              src={img}
              className='d-none d-xl-block vh-100 w-100'
              style={{ objectFit: "cover" }}
            //alt='cover image'
            />}
          </div>
          <div className="col-12 col-xl-6">
            <Routes>
              <Route path='/' element={<Navigate to='/signup' />} />
              <Route path='/signup' element={<Signup />} />
              <Route path='/login' element={<Login />} />
            </Routes>
          </div>
        </div>}
    </>
  )
}

export default App
